export { defaultTheme } from './defaultTheme'
